import { type SingleTripCancellationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/stc';
import { type OPCRowInformation } from '../../../../config/flavourConfig';

const getSingleTripCancellationAdjustDetailsConfig = (
    stt: SingleTripCancellationDTO
): OPCRowInformation[] => {
    return [];
};

export default getSingleTripCancellationAdjustDetailsConfig;
